import {putEntrust} from '../model/trader/entrustServes'
import { toApp } from '@/utils/appBridge'
import { store } from '@/observable/store'

export const promptly = (uuid,vue,tmpl,isOrder) =>{
    let wxFlag,systemFlag;
    if(vue.CHANNAL_ID == 'JSAPI'){
        wxFlag = '1';
    }else{
        wxFlag = '0';
    }
    // 0 - web，1 - ios，2 - android，3 - H5/M，4 - 公众号, 
    if(vue.CHANNAL_ID == 'APP'){
        if(vue.IOS_AND == 'IOS'){
            systemFlag = '1'
        }
        if(vue.IOS_AND == 'Android'){
            systemFlag = '2'
        }
    }
    if(vue.CHANNAL_ID == 'MWEB'){
        systemFlag = '3'
    }
    if(vue.CHANNAL_ID == 'JSAPI'){
        systemFlag = '4'
    }
    
    let parmre = {
        "pay_type": "3",
        "system": systemFlag,
        "is_weixin":wxFlag,   
        "url": window.location.origin,
        "from_action": Array.isArray(vue.$route.query.from_action)?vue.$route.query.from_action[0] : vue.$route.query.from_action || store.refid.item_id || '',
    }
    if(uuid){
        // 保单签约
        putEntrust(uuid,parmre).then(data =>{
            console.log(data);
            if(data.has_entrust === 0){
                // entrust_serial签约序列号
                let parme = {
                    entrust_serial:data.entrust_serial,
                    uuid:uuid,
                    templateFlag:tmpl,
                }
                if(data.entrust_info){
                    // entrust_info 微信签约数据
                    const url = `${window.location.origin}/receiving?order_paramer=${encodeURIComponent(JSON.stringify(parme))}&needRefresh=1`
                    if(vue.CHANNAL_ID == 'APP'){
                        toApp('signed',{
                            signed_id:data.entrust_info.pre_entrustweb_id,
                            order_paramer: encodeURIComponent(JSON.stringify(parme)),
                            app_success_url:`${window.location.origin}/api/index?sybao=boy&url=${encodeURIComponent(url)}`
                        })
                    }else{
                        let order_paramer = {
                            entrust_serial:data.entrust_serial,
                            uuid:uuid,
                            templateFlag:tmpl,
                        }
                        if(vue.CHANNAL_ID == 'JSAPI'){
                            vue.$router.push({
                                path: "/receiving",
                                query:{
                                    isNoApp:true,
                                    order_paramer:encodeURIComponent(JSON.stringify(order_paramer)),
                                    flag : 'postdisable',
                                    uri:data.entrust_info.redirect_url
                                }
                            });
                        }else{
                            // 微信内
                            vue.$router.push({
                                path: "/receiving",
                                query:{
                                    isNoApp:true,
                                    entrust_serial:data.entrust_serial,
                                    uuid:uuid,
                                    flag : 'postdisable',
                                    templateFlag:tmpl,
                                    uri:data.entrust_info.redirect_url
                                }
                            });
                        }
                    } 
                }
            }
        }).catch(err => {
            console.log(err)
            if(isOrder == 'order'){
                vue.toastFnOrder()
            }else{
                vue.$refs.toast.showoast(err.message);
            }
        })
    }else {
        vue.$refs.toast.showoast("订单id不存在");
    }
    
}